export const PuissanceMonophase = [
  { key: "3A", value: "3A" },
  { key: "5A", value: "5A" },
  { key: "10A", value: "10A" },
  { key: "15A", value: "15A" },
  { key: "20A", value: "20A" },
  { key: "25A", value: "25A" },
  { key: "30A", value: "30A" },
];
